module.exports = __webpack_public_path__ + "static/img/footer-link.8c91ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-link.png
// module id = wgj1
// module chunks = 20